import { render, staticRenderFns } from "./ClassificationsTable.vue?vue&type=template&id=00c854ed&scoped=true&lang=pug&"
import script from "./ClassificationsTable.vue?vue&type=script&lang=js&"
export * from "./ClassificationsTable.vue?vue&type=script&lang=js&"
import style0 from "./ClassificationsTable.vue?vue&type=style&index=0&id=00c854ed&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c854ed",
  null
  
)

export default component.exports